
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 220 160"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","stroke":"#0038b8","stroke-width":"5.5","fill-opacity":"0","d":"M0-29.141l-25.237 43.712h50.474z"}})]),_c('path',{attrs:{"fill":"#fff","d":"M0 0h220v160H0z"}}),_c('path',{attrs:{"fill":"#0038b8","d":"M0 15h220v25H0zM0 120h220v25H0z"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"translate(110 80)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(180 55 40)"}})])
          )
        }
      }
    